import { find, get } from 'lodash'

type FormattedAddressDetails = {
  city?: string
  neighbourhood?: string
  number?: string
  state?: string
  street?: string
  zip_code?: string
  coordinates?: {
    latitude: number
    longitude: number
    latitudeDelta: number
    longitudeDelta: number
  }
}

const findAddressComponentByType = (addressComponents, type) =>
  find(addressComponents, (o) => o.types.includes(type))

export const getFormattedAddressDetails = (details) => {
  const formattedAddressDetails: FormattedAddressDetails = {}
  const addressComponents = details.address_components
  const locationCoordinates = details.geometry.location
  const viewportCoordinates = details.geometry.viewport

  const zip_code = findAddressComponentByType(addressComponents, 'postal_code')
  const street = findAddressComponentByType(addressComponents, 'route')
  const number = findAddressComponentByType(addressComponents, 'street_number')
  const neighbourhood = findAddressComponentByType(addressComponents, 'sublocality_level_1')
  const city = findAddressComponentByType(addressComponents, 'administrative_area_level_2')
  const state = findAddressComponentByType(addressComponents, 'administrative_area_level_1')

  if (zip_code) formattedAddressDetails.zip_code = zip_code.long_name
  if (street) formattedAddressDetails.street = street.long_name
  formattedAddressDetails.number = number ? number.long_name : 'S/N'
  if (neighbourhood) formattedAddressDetails.neighbourhood = neighbourhood.long_name
  if (city) formattedAddressDetails.city = city.long_name
  if (state) formattedAddressDetails.state = state.short_name

  formattedAddressDetails.coordinates = {
    latitude: locationCoordinates.lat(),
    longitude: locationCoordinates.lng(),
    latitudeDelta:
      Number(get(viewportCoordinates, 'Va.i', 0)) - Number(get(viewportCoordinates, 'Va.j', 0)),
    longitudeDelta:
      Number(get(viewportCoordinates, 'Za.i', 0)) - Number(get(viewportCoordinates, 'Za.j', 0)),
  }

  return formattedAddressDetails
}

export const getAddressString = (address) => {
  const { street, city, state } = address
  const streetString = street.trim() ? `${street.trim()}, ` : ''
  const cityString = city.trim() ? `${city.trim()} ` : ''
  const stateString = state.trim() ? `- ${state.trim()}` : ''
  return streetString + cityString + stateString
}
